
import { Inject, Injectable, DOCUMENT } from "@angular/core";

/* eslint-disable-next-line no-var */
declare var grecaptcha: any;

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {
  recaptchaSiteKey: string | null = null;
  loaded = false;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
  ) {}

  public load(recaptchaSiteKey: string): void {
    if (this.loaded) {
      return;
    }

    this.recaptchaSiteKey = recaptchaSiteKey;

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${this.recaptchaSiteKey}`;

    this.document.head.appendChild(script);

    this.loaded = true;
  }

  public execute(action: string, callback: (token: string) => void): void {
    if (!this.recaptchaSiteKey) {
      throw new Error('Recaptcha site key is not set.');
    }

    grecaptcha.ready(() => {
      grecaptcha.execute(this.recaptchaSiteKey, { action })
        .then(callback);
    });
  }
}
